import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./redux/store";
import { Provider } from "react-redux";
import "./styles/reset.css";
import WebFont from "webfontloader";

import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
// SITE KEY 6LdpF3sfAAAAANu8BZA8XVU5WktGXZ8WjatuNNxz
// serverSide 6LdpF3sfAAAAAFS9bA3S4EdhJFwkl50Ex6A64qXL
WebFont.load({
  google: {
    families: ["jack", "sans-Serif"],
  },
});
ReactDOM.render(
  <GoogleReCaptchaProvider
    reCaptchaKey={true}
    // language="[optional_language]"
    // useRecaptchaNet="[optional_boolean_value]"
    // useEnterprise="[optional_boolean_value]"
    scriptProps={{
      async: false, // optional, default to false,
      defer: false, // optional, default to false
      appendTo: "head", // optional, default to "head", can be "head" or "body",
      nonce: undefined, // optional, default undefined
    }}
  >
    <Provider store={store}>
      <App />
    </Provider>
  </GoogleReCaptchaProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
